module.exports = __webpack_public_path__ + "img/blueBackArrow.9c3447b7.svg";